import React, { ChangeEvent, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import SecondaryButton from "../../../../components/button/secondaryButton";
import { Input } from "@mui/material";
import useAuth from "../../../../hooks/useAuth";
import { isString, useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { UploadMedia } from "../../../../utils/mediaUpload";
import { Loader, errorToast } from "../../../../helpers";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLazyGetProfileQuery,
  usePutUpdateProfileMutation,
} from "../../../../service/Auth";

const ProfileContent = () => {
  const location = useLocation();
  const { state } = location;
  console.log("state: ", state);
  const userData = useAuth();
  const navigate = useNavigate();

  const [image, setImage] = useState<string>("");
  const [phoneCode, setPhoneCode] = useState("+91");
  const [error, setError] = useState(false);
  const [frontImg, setFrontImg] = useState<string>("");
  const [backImg, setBackImg] = useState<string>("");

  const [updateProfileMethod, updateProfileMutation] =
    usePutUpdateProfileMutation();
  const [getProfileMethod] = useLazyGetProfileQuery();

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneCode(country?.dialCode);
  };

  const handleImageUpload = async (
    event: ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    try {
      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        if (key === "profile") {
          setImage(res?.data);
        } else if (key === "front") {
          setFrontImg(res?.data);
        } else {
          setBackImg(res?.data);
        }
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProfileData = async () => {
    try {
      await getProfileMethod({}).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: userData?.firstName || "",
      lastName: userData?.lastName || "",
      email: userData?.email || "",
      street: userData?.address1 || "",
      phone: userData?.phone || "",
      location: userData?.locationKey || "",
      zipCode: userData?.zipCode || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .required("First name is required")
        .min(2, "Minimum 2 characters are required"),
      lastName: Yup.string()
        .required("Last name is required")
        .min(2, "Minimum 2 characters are required"),
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address!"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
      street: Yup.string()
        .required("Street is required")
        .min(2, "Minimum 2 characters are required"),
      location: Yup.string()
        .required("Location is required")
        .min(2, "Minimum 2 characters are required"),
      zipCode: Yup.string()
        .required("Zipcode is required")
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      let body = {
        firstName: formik.values.firstName,
        lastName: formik.values.lastName,
        phone: formik.values.phone,
        countryCode: phoneCode,
        email: formik.values.email,
        address1: formik.values.street,
        userLocation: {
          lat: -34.928567,
          lng: -56.168106,
        },
        zipCode: formik.values.zipCode?.toString(),
        profilePic: image,
        documentFrontImage: frontImg,
        documentBackImage: backImg,
        locationKey: formik.values.location,
      };

      try {
        const response = await updateProfileMethod(body).unwrap();
        if (response?.statusCode === 200) {
          navigate("/view-profile", { replace: true });
          getProfileData();
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
      }
    },
  });

  useEffect(() => {
    if (userData) {
      setPhoneCode(userData?.countryCode || "+91");
      setBackImg(userData?.documentBackImage || "");
      setFrontImg(userData?.documentFrontImage || "");
      setImage(userData?.profilePic || "");
    }
  }, [userData]);

  return (
    <>
      <Loader isLoad={updateProfileMutation?.isLoading} />
      <section className="auth_page ut_spc">
        <div className="conta_iner">
          <div className="right_side small_width">
            <form onSubmit={formik.handleSubmit}>
              <div className="form_control">
                {image ? (
                  <div className="upload_image">
                    <div className="cross_icn2">
                      <CloseIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          setImage("");
                        }}
                      />
                    </div>
                    <figure>
                      <img
                        src={image ? image : "/images/user_placeholder.svg"}
                        alt=""
                      />
                    </figure>
                  </div>
                ) : (
                  <label htmlFor="icon-button-file" className="upload_image">
                    <>
                      <span>
                        <img src="/images/user_placeholder.svg" alt="" />
                      </span>
                      <Input
                        //   sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "image/png,image/jpeg",
                        }}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          handleImageUpload(e, "profile")
                        }
                      />
                    </>
                  </label>
                )}
                {error && !image ? (
                  <h6 className="err_msg">This field is required</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="gap_p">
                <div className="form_control w_50">
                  <TextField
                    hiddenLabel
                    fullWidth
                    type="text"
                    placeholder="First Name"
                    name="firstName"
                    variant="outlined"
                    id="firstName"
                    className="text_field"
                    onChange={(val) => {
                      if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                    helperText={
                      formik.touched.firstName && formik.errors.firstName
                    }
                    inputProps={{ maxLength: 20 }}
                  />
                </div>
                <div className="form_control w_50">
                  <TextField
                    hiddenLabel
                    fullWidth
                    type="text"
                    placeholder="Last Name"
                    name="lastName"
                    variant="outlined"
                    id="lastName"
                    className="text_field"
                    onChange={(val) => {
                      if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastName}
                    helperText={
                      formik.touched.lastName && formik.errors.lastName
                    }
                    inputProps={{ maxLength: 20 }}
                  />
                </div>
              </div>
              <div className="form_control">
                <TextField
                  hiddenLabel
                  fullWidth
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  variant="outlined"
                  id="email"
                  className="text_field"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>
              <div className="form_control">
                <PhoneInput
                  enableSearch={true}
                  value={phoneCode + formik.values.phone}
                  country={"us"}
                  inputClass="phoneInput"
                  // inputStyle={{
                  //   color: "white",
                  //   width: "100%",
                  //   background: "#373737",
                  //   border: "1px solid transparent",
                  // }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  onBlur={formik.handleBlur}
                />
                {error && !formik.values.phone ? (
                  <h6 className="err_msg">Phone number is required</h6>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="form_control">
                <TextField
                  disabled
                  hiddenLabel
                  fullWidth
                  type="wAddress"
                  placeholder="Wallet Address"
                  name="email"
                  variant="outlined"
                  id="wAddress"
                  className="text_field"
                  value={userData?.walletAddress}
                />
              </div> */}
              <h3>Address</h3>
              <div className="form_control">
                <TextField
                  hiddenLabel
                  fullWidth
                  type="text"
                  placeholder="Street Name"
                  name="street"
                  variant="outlined"
                  id="street"
                  className="text_field"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.street}
                  helperText={formik.touched.street && formik.errors.street}
                  inputProps={{ maxLength: 30 }}
                />
              </div>
              <div className="form_control">
                <TextField
                  hiddenLabel
                  fullWidth
                  type="text"
                  placeholder="Location (Google Places API)"
                  name="location"
                  variant="outlined"
                  id="location"
                  className="text_field"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.location}
                  helperText={formik.touched.location && formik.errors.location}
                />
              </div>
              <div className="form_control">
                <TextField
                  hiddenLabel
                  fullWidth
                  type="text"
                  placeholder="Pincode/Zipcode"
                  name="zipCode"
                  id="zipCode"
                  className="text_field"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.zipCode}
                  helperText={formik.touched.zipCode && formik.errors.zipCode}
                  inputProps={{ maxLength: 10 }}
                />
              </div>

              {/* <h3>Document</h3> */}
              {/* <div className="form_control">
                <div className="gap_p"> */}
              {/* <div className="upload_document w_50">
                    <label htmlFor="icon-button-file-front" className="inner">
                      {frontImg ? (
                        <>
                          <div className="cross_icn">
                            <CloseIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                setFrontImg("");
                              }}
                            />
                          </div>
                          <figure>
                            <img src={frontImg} alt="" />
                          </figure>
                        </>
                      ) : (
                        <>
                          <span>
                            <img src="../../images/icon_upload.svg" alt="" />
                            Drop your files here
                          </span>
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-front"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              handleImageUpload(e, "front")
                            }
                          />
                        </>
                      )}
                    </label>
                    {error && !frontImg ? (
                      <h6 className="err_msg">This field is required</h6>
                    ) : null}
                  </div> */}
              {/* <div className="upload_document w_50">
                    {frontImg ? (
                      <div className="inner">
                        <div className="cross_icn">
                          <CloseIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              setFrontImg("");
                            }}
                          />
                        </div>

                        <figure>
                          <img src={frontImg} alt="" />
                        </figure>
                      </div>
                    ) : (
                      <label htmlFor="icon-button-file-front">
                        <div className="inner">
                          <span>
                            <img src="../../images/icon_upload.svg" alt="" />
                            Drag & Drop your files here
                          </span>
                          <Input
                            id="icon-button-file-front"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleImageUpload(e, "front")}
                          />
                        </div>

                        {error && !frontImg ? (
                          <h6 className="err_msg">This field is required</h6>
                        ) : null}
                      </label>
                    )}
                  </div> */}
              {/* <div className="upload_document w_50">
                    {backImg ? (
                      <div className="inner">
                        <div className="cross_icn">
                          <CloseIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              setBackImg("");
                            }}
                          />
                        </div>

                        <figure>
                          <img src={backImg} alt="" />
                        </figure>
                      </div>
                    ) : (
                      <label htmlFor="icon-button-file-back">
                        <div className="inner">
                          <span>
                            <img src="../../images/icon_upload.svg" alt="" />
                            Drag & Drop your files here
                          </span>
                          <Input
                            id="icon-button-file-back"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleImageUpload(e, "back")}
                          />
                        </div>

                        {error && !backImg ? (
                          <h6 className="err_msg">This field is required</h6>
                        ) : null}
                      </label>
                    )}
                  </div> */}
              {/* <div className="upload_document w_50">
                    <label htmlFor="icon-button-file-back" className="inner">
                      {backImg ? (
                        <>
                          <div className="cross_icn">
                            <CloseIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                setBackImg("");
                              }}
                            />
                          </div>
                          <figure>
                            <img src={backImg} alt="" />
                          </figure>
                        </>
                      ) : (
                        <>
                          <span>
                            <img src="../../images/icon_upload.svg" alt="" />
                            Drag & Drop your files here
                          </span>
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file-back"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              handleImageUpload(e, "back")
                            }
                          />
                        </>
                      )}
                    </label>
                    {error && !backImg ? (
                      <h6 className="err_msg">This field is required</h6>
                    ) : null}
                  </div> */}
              {/* </div>
              </div> */}
              <div className="form_btn">
                <SecondaryButton
                  content="Save"
                  onClick={() => setError(true)}
                />
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfileContent;
